import { Text } from '@components/core'

export interface CryptoPrice {
  price: number
  time: string
}

export interface CryptoPrices {
  currency: string
  name: string
  image: string
  total: number
  description: string
  prices: CryptoPrice[]
}

export const TRENDING = [
  {
    id: 1,
    title: 'Bitcoin',
    abbr: 'BTC',
    image: '/images/crypto/bitcoin.png',
    footer: (
      <Text contrast="low" weight="medium" size="sm" color="red">
        -0.5%
      </Text>
    ),
  },
  {
    id: 2,
    title: 'BNB',
    abbr: 'BNB',
    image: '/images/crypto/bnb.png',
    footer: (
      <Text contrast="low" weight="medium" size="sm" color="red">
        -0.2%
      </Text>
    ),
  },
  {
    id: 3,
    title: 'Ethereum',
    image: '/images/crypto/ethereum.png',
    abbr: 'ETH',
    footer: (
      <Text contrast="low" weight="medium" size="sm" color="green">
        +0.7%
      </Text>
    ),
  },
  {
    id: 4,
    title: 'Marker',
    image: '/images/crypto/maker.png',
    abbr: 'MKR',
    footer: (
      <Text contrast="low" weight="medium" size="sm" color="green">
        +1.1%
      </Text>
    ),
  },
]

export const RECENT_ADDED = [
  {
    id: 1,
    title: 'Polygon',
    abbr: 'MATIC',
    image: '/images/crypto/polygon.png',
    footer: (
      <Text contrast="low" size="xs" color="slate">
        $0.7931
      </Text>
    ),
  },
  {
    id: 2,
    title: 'Dodge Coin',
    abbr: 'DOGE',
    image: '/images/crypto/dodge-coin.png',
    footer: (
      <Text contrast="low" size="xs" color="slate">
        $0.07579
      </Text>
    ),
  },
  {
    id: 3,
    title: 'Decred',
    image: '/images/crypto/decred.png',
    abbr: 'DCR',
    footer: (
      <Text contrast="low" size="xs" color="slate">
        $19.35
      </Text>
    ),
  },
  {
    id: 4,
    title: 'XRP',
    image: '/images/crypto/xrp.png',
    abbr: 'XRP',
    footer: (
      <Text contrast="low" size="xs" color="slate">
        $0.0035
      </Text>
    ),
  },
]

export const TOP_ACCOUNT = [
  {
    id: 1,
    title: 'Hamza Miloud Amar',
    abbr: '@miloud-amar',
    image: 'https://i.pravatar.cc/150?img=1',
  },
  {
    id: 2,
    title: 'Jared Lorem',
    abbr: '@jaredlorem',
    image: 'https://i.pravatar.cc/150?img=2',
  },
  {
    id: 3,
    title: 'Kent Florence',
    image: 'https://i.pravatar.cc/150?img=3',
    abbr: '@kent-florence',
  },
]

export const bitcoin: CryptoPrices = {
  currency: 'BTC',
  name: 'Bitcoin',
  image: 'bitcoin.png',
  description: `Bitcoin is a decentralized cryptocurrency originally described in a 2008 whitepaper by a person, or group of people, using the alias Satoshi Nakamoto. It was launched soon after, in January 2009.

  Bitcoin is a peer-to-peer online currency, meaning that all transactions happen directly between equal, independent network participants, without the need for any intermediary to permit or facilitate them. Bitcoin was created, according to Nakamoto’s own words, to allow “online payments to be sent directly from one party to another without going through a financial institution.”
  
  Some concepts for a similar type of a decentralized electronic currency precede BTC, but Bitcoin holds the distinction of being the first-ever cryptocurrency to come into actual use.`,
  total: 21303652,
  prices: [
    { price: 2677.86, time: '2022-12-22T00:00:00Z' },
    { price: 2672.44, time: '2022-12-21T00:00:00Z' },
    { price: 2604.15, time: '2022-12-20T00:00:00Z' },
    { price: 2560.02, time: '2022-12-19T00:00:00Z' },
    { price: 2560.02, time: '2022-12-18T00:00:00Z' },
    { price: 2496.85, time: '2022-12-17T00:00:00Z' },
    { price: 2396.05, time: '2022-12-16T00:00:00Z' },
    { price: 2510.72, time: '2022-12-15T00:00:00Z' },
    { price: 2691.87, time: '2022-12-14T00:00:00Z' },
    { price: 2767.11, time: '2022-12-13T00:00:00Z' },
    { price: 2875.4, time: '2022-12-12T00:00:00Z' },
    { price: 2893.7, time: '2022-12-11T00:00:00Z' },
    { price: 2840.12, time: '2022-12-10T00:00:00Z' },
    { price: 2787.07, time: '2022-12-09T00:00:00Z' },
    { price: 2784.1, time: '2022-12-08T00:00:00Z' },
    { price: 2691.87, time: '2022-12-07T00:00:00Z' },
    { price: 2767.11, time: '2022-12-06T00:00:00Z' },
    { price: 2875.4, time: '2022-12-05T00:00:00Z' },
    { price: 2893.7, time: '2022-12-04T00:00:00Z' },
    { price: 2486.69, time: '2022-12-03T00:00:00Z' },
    { price: 2457.05, time: '2022-12-02T00:00:00Z' },
    { price: 2486.09, time: '2022-12-01T00:00:00Z' },
    { price: 2535.85, time: '2022-11-30T00:00:00Z' },
    { price: 2546.06, time: '2022-11-29T00:00:00Z' },
    { price: 2465.83, time: '2022-11-28T00:00:00Z' },
    { price: 2424.59, time: '2022-11-27T00:00:00Z' },
    { price: 2503.52, time: '2022-11-26T00:00:00Z' },
    { price: 2605.97, time: '2022-11-25T00:00:00Z' },
    { price: 2681.55, time: '2022-11-24T00:00:00Z' },
    { price: 2685.69, time: '2022-11-23T00:00:00Z' },
    { price: 2677.86, time: '2022-11-22T00:00:00Z' },
    { price: 2672.44, time: '2022-11-21T00:00:00Z' },
    { price: 2604.15, time: '2022-11-20T00:00:00Z' },
    { price: 2560.02, time: '2022-11-19T00:00:00Z' },
    { price: 2560.02, time: '2022-11-18T00:00:00Z' },
    { price: 2496.85, time: '2022-11-17T00:00:00Z' },
    { price: 2396.05, time: '2022-11-16T00:00:00Z' },
    { price: 2510.72, time: '2022-11-15T00:00:00Z' },
    { price: 2691.87, time: '2022-11-14T00:00:00Z' },
    { price: 2767.11, time: '2022-11-13T00:00:00Z' },
    { price: 2875.4, time: '2022-11-12T00:00:00Z' },
    { price: 2893.7, time: '2022-11-11T00:00:00Z' },
    { price: 2840.12, time: '2022-11-10T00:00:00Z' },
    { price: 2787.07, time: '2022-11-09T00:00:00Z' },
    { price: 2784.1, time: '2022-11-08T00:00:00Z' },
    { price: 2691.87, time: '2022-11-07T00:00:00Z' },
    { price: 2767.11, time: '2022-11-06T00:00:00Z' },
    { price: 2875.4, time: '2022-11-05T00:00:00Z' },
    { price: 2893.7, time: '2022-11-04T00:00:00Z' },
    { price: 2840.12, time: '2022-11-03T00:00:00Z' },
    { price: 2787.07, time: '2022-11-02T00:00:00Z' },
    { price: 2784.1, time: '2022-11-01T00:00:00Z' },
  ],
}

export const polygon: CryptoPrices = {
  currency: 'MATIC',
  name: 'Polygon',
  total: 22556332,
  description: `Polygon (previously Matic Network) is the first well-structured, easy-to-use platform for Ethereum scaling and infrastructure development. Its core component is Polygon SDK, a modular, flexible framework that supports building multiple types of applications.

  To learn more about this project, check out our deep dive of Polygon Matic.
  
  Using Polygon, one can create optimistic rollup chains, ZK rollup chains, stand alone chains or any other kind of infra required by the developer.
  
  Polygon effectively transforms Ethereum into a full-fledged multi-chain system (aka Internet of Blockchains). This multi-chain system is akin to other ones such as Polkadot, Cosmos, Avalanche etc. with the advantages of Ethereum’s security, vibrant ecosystem and openness.`,
  image: 'polygon.png',
  prices: [
    { price: 0.8602, time: '2022-12-22T00:00:00Z' },
    { price: 0.4402, time: '2022-12-21T00:00:00Z' },
    { price: 0.1502, time: '2022-12-20T00:00:00Z' },
    { price: 0.0202, time: '2022-12-19T00:00:00Z' },
    { price: 0.0202, time: '2022-12-18T00:00:00Z' },
    { price: 0.8502, time: '2022-12-17T00:00:00Z' },
    { price: 0.0502, time: '2022-12-16T00:00:00Z' },
    { price: 0.7202, time: '2022-12-15T00:00:00Z' },
    { price: 0.8702, time: '2022-12-14T00:00:00Z' },
    { price: 0.1102, time: '2022-12-13T00:00:00Z' },
    { price: 0.4002, time: '2022-12-12T00:00:00Z' },
    { price: 0.7002, time: '2022-12-11T00:00:00Z' },
    { price: 0.1202, time: '2022-12-10T00:00:00Z' },
    { price: 0.0702, time: '2022-12-09T00:00:00Z' },
    { price: 0.1002, time: '2022-12-08T00:00:00Z' },
    { price: 0.8702, time: '2022-12-07T00:00:00Z' },
    { price: 0.1102, time: '2022-12-06T00:00:00Z' },
    { price: 0.4002, time: '2022-12-05T00:00:00Z' },
    { price: 0.7002, time: '2022-12-04T00:00:00Z' },
    { price: 0.6902, time: '2022-12-03T00:00:00Z' },
    { price: 0.0502, time: '2022-12-02T00:00:00Z' },
    { price: 0.0902, time: '2022-12-01T00:00:00Z' },
    { price: 0.8536, time: '2022-11-30T00:00:00Z' },
    { price: 0.0686, time: '2022-11-29T00:00:00Z' },
    { price: 0.8386, time: '2022-11-28T00:00:00Z' },
    { price: 0.5986, time: '2022-11-27T00:00:00Z' },
    { price: 0.5236, time: '2022-11-26T00:00:00Z' },
    { price: 0.9775, time: '2022-11-25T00:00:00Z' },
    { price: 0.5536, time: '2022-11-24T00:00:00Z' },
    { price: 0.6935, time: '2022-11-23T00:00:00Z' },
    { price: 0.8685, time: '2022-11-22T00:00:00Z' },
    { price: 0.4436, time: '2022-11-21T00:00:00Z' },
    { price: 0.1536, time: '2022-11-20T00:00:00Z' },
    { price: 0.0236, time: '2022-11-19T00:00:00Z' },
    { price: 0.4253, time: '2022-11-18T00:00:00Z' },
    { price: 0.8536, time: '2022-11-17T00:00:00Z' },
    { price: 0.0536, time: '2022-11-16T00:00:00Z' },
    { price: 0.7236, time: '2022-11-15T00:00:00Z' },
    { price: 0.8736, time: '2022-11-14T00:00:00Z' },
    { price: 0.1175, time: '2022-11-13T00:00:00Z' },
    { price: 0.4036, time: '2022-11-12T00:00:00Z' },
    { price: 0.7096, time: '2022-11-11T00:00:00Z' },
    { price: 0.1236, time: '2022-11-10T00:00:00Z' },
    { price: 0.0736, time: '2022-11-09T00:00:00Z' },
    { price: 0.1036, time: '2022-11-08T00:00:00Z' },
    { price: 0.8775, time: '2022-11-07T00:00:00Z' },
    { price: 0.1136, time: '2022-11-06T00:00:00Z' },
    { price: 0.4036, time: '2022-11-05T00:00:00Z' },
    { price: 0.7089, time: '2022-11-04T00:00:00Z' },
    { price: 0.1235, time: '2022-11-03T00:00:00Z' },
    { price: 0.0725, time: '2022-11-02T00:00:00Z' },
    { price: 0.1012, time: '2022-11-01T00:00:00Z' },
  ],
}

export const ethereum: CryptoPrices = {
  currency: 'ETH',
  name: 'Ethereum',
  total: 15425563,
  description: `Ethereum is a decentralized open-source blockchain system that features its own cryptocurrency, Ether. ETH works as a platform for numerous other cryptocurrencies, as well as for the execution of decentralized smart contracts.
  Ethereum was first described in a 2013 whitepaper by Vitalik Buterin. Buterin, along with other co-founders, secured funding for the project in an online public crowd sale in the summer of 2014. The project team managed to raise $18.3 million in Bitcoin, and Ethereum’s price in the Initial Coin Offering (ICO) was $0.311, with over 60 million Ether sold. Taking Ethereum’s price now, this puts the return on investment (ROI) at an annualized rate of over 270%, essentially almost quadrupling your investment every year since the summer of 2014.`,
  image: 'ethereum.png',
  prices: [
    { price: 1223.86, time: '2022-12-22T00:00:00Z' },
    { price: 1215.44, time: '2022-12-21T00:00:00Z' },
    { price: 1225.15, time: '2022-12-20T00:00:00Z' },
    { price: 1252.02, time: '2022-12-19T00:00:00Z' },
    { price: 1220.02, time: '2022-12-18T00:00:00Z' },
    { price: 1223.85, time: '2022-12-17T00:00:00Z' },
    { price: 1002.05, time: '2022-12-16T00:00:00Z' },
    { price: 1010.72, time: '2022-12-15T00:00:00Z' },
    { price: 1120.87, time: '2022-12-14T00:00:00Z' },
    { price: 1350.11, time: '2022-12-13T00:00:00Z' },
    { price: 1290.4, time: '2022-12-12T00:00:00Z' },
    { price: 1260.7, time: '2022-12-11T00:00:00Z' },
    { price: 1298.12, time: '2022-12-10T00:00:00Z' },
    { price: 1500.07, time: '2022-12-09T00:00:00Z' },
    { price: 1532.1, time: '2022-12-08T00:00:00Z' },
    { price: 1650.87, time: '2022-12-07T00:00:00Z' },
    { price: 1456.11, time: '2022-12-06T00:00:00Z' },
    { price: 1492.4, time: '2022-12-05T00:00:00Z' },
    { price: 1396.7, time: '2022-12-04T00:00:00Z' },
    { price: 1389.69, time: '2022-12-03T00:00:00Z' },
    { price: 1345.05, time: '2022-12-02T00:00:00Z' },
    { price: 1485.09, time: '2022-12-01T00:00:00Z' },
    { price: 1525.85, time: '2022-11-30T00:00:00Z' },
    { price: 1526.06, time: '2022-11-29T00:00:00Z' },
    { price: 1547.83, time: '2022-11-28T00:00:00Z' },
    { price: 1596.59, time: '2022-11-27T00:00:00Z' },
    { price: 1573.52, time: '2022-11-26T00:00:00Z' },
    { price: 1456.97, time: '2022-11-25T00:00:00Z' },
    { price: 1352.55, time: '2022-11-24T00:00:00Z' },
    { price: 1369.69, time: '2022-11-23T00:00:00Z' },
    { price: 1348.86, time: '2022-11-22T00:00:00Z' },
    { price: 1389.44, time: '2022-11-21T00:00:00Z' },
    { price: 1395.15, time: '2022-11-20T00:00:00Z' },
    { price: 1356.02, time: '2022-11-19T00:00:00Z' },
    { price: 1485.02, time: '2022-11-18T00:00:00Z' },
    { price: 1369.85, time: '2022-11-17T00:00:00Z' },
    { price: 1387.05, time: '2022-11-16T00:00:00Z' },
    { price: 1699.72, time: '2022-11-15T00:00:00Z' },
    { price: 1785.87, time: '2022-11-14T00:00:00Z' },
    { price: 1789.11, time: '2022-11-13T00:00:00Z' },
    { price: 1855.4, time: '2022-11-12T00:00:00Z' },
    { price: 1759.7, time: '2022-11-11T00:00:00Z' },
    { price: 1900.12, time: '2022-11-10T00:00:00Z' },
    { price: 1999.07, time: '2022-11-09T00:00:00Z' },
    { price: 1968.1, time: '2022-11-08T00:00:00Z' },
    { price: 1859.87, time: '2022-11-07T00:00:00Z' },
    { price: 1598.11, time: '2022-11-06T00:00:00Z' },
    { price: 1969.4, time: '2022-11-05T00:00:00Z' },
    { price: 1923.7, time: '2022-11-04T00:00:00Z' },
    { price: 1963.12, time: '2022-11-03T00:00:00Z' },
    { price: 1963.07, time: '2022-11-02T00:00:00Z' },
    { price: 1987.1, time: '2022-11-01T00:00:00Z' },
  ],
}

export const bnb: CryptoPrices = {
  currency: 'BNB',
  name: 'BNB',
  image: 'bnb.png',
  description: `Launched in July 2017, Binance is the biggest cryptocurrency exchange globally based on daily trading volume. Binance aims to bring cryptocurrency exchanges to the forefront of financial activity globally. The idea behind Binance’s name is to show this new paradigm in global finance — Binary Finance, or Binance.`,
  total: 19854568,
  prices: [
    { price: 246.01, time: '2022-12-22T00:00:00Z' },
    { price: 246.01, time: '2022-12-21T00:00:00Z' },
    { price: 246.01, time: '2022-12-20T00:00:00Z' },
    { price: 246.01, time: '2022-12-19T00:00:00Z' },
    { price: 246.01, time: '2022-12-18T00:00:00Z' },
    { price: 246.01, time: '2022-12-17T00:00:00Z' },
    { price: 246.01, time: '2022-12-16T00:00:00Z' },
    { price: 246.01, time: '2022-12-15T00:00:00Z' },
    { price: 246.01, time: '2022-12-14T00:00:00Z' },
    { price: 246.01, time: '2022-12-13T00:00:00Z' },
    { price: 246.01, time: '2022-12-12T00:00:00Z' },
    { price: 246.01, time: '2022-12-11T00:00:00Z' },
    { price: 246.01, time: '2022-12-10T00:00:00Z' },
    { price: 246.01, time: '2022-12-09T00:00:00Z' },
    { price: 246.01, time: '2022-12-08T00:00:00Z' },
    { price: 246.01, time: '2022-12-07T00:00:00Z' },
    { price: 246.01, time: '2022-12-06T00:00:00Z' },
    { price: 246.01, time: '2022-12-05T00:00:00Z' },
    { price: 246.01, time: '2022-12-04T00:00:00Z' },
    { price: 246.01, time: '2022-12-03T00:00:00Z' },
    { price: 246.01, time: '2022-12-02T00:00:00Z' },
    { price: 246.01, time: '2022-12-01T00:00:00Z' },
    { price: 225.85, time: '2022-11-30T00:00:00Z' },
    { price: 226.06, time: '2022-11-29T00:00:00Z' },
    { price: 247.83, time: '2022-11-28T00:00:00Z' },
    { price: 296.59, time: '2022-11-27T00:00:00Z' },
    { price: 273.52, time: '2022-11-26T00:00:00Z' },
    { price: 456.97, time: '2022-11-25T00:00:00Z' },
    { price: 352.55, time: '2022-11-24T00:00:00Z' },
    { price: 369.69, time: '2022-11-23T00:00:00Z' },
    { price: 348.86, time: '2022-11-22T00:00:00Z' },
    { price: 389.44, time: '2022-11-21T00:00:00Z' },
    { price: 395.15, time: '2022-11-20T00:00:00Z' },
    { price: 356.02, time: '2022-11-19T00:00:00Z' },
    { price: 485.02, time: '2022-11-18T00:00:00Z' },
    { price: 369.85, time: '2022-11-17T00:00:00Z' },
    { price: 387.05, time: '2022-11-16T00:00:00Z' },
    { price: 199.72, time: '2022-11-15T00:00:00Z' },
    { price: 285.87, time: '2022-11-14T00:00:00Z' },
    { price: 289.11, time: '2022-11-13T00:00:00Z' },
    { price: 155.4, time: '2022-11-12T00:00:00Z' },
    { price: 259.7, time: '2022-11-11T00:00:00Z' },
    { price: 100.12, time: '2022-11-10T00:00:00Z' },
    { price: 199.07, time: '2022-11-09T00:00:00Z' },
    { price: 168.1, time: '2022-11-08T00:00:00Z' },
    { price: 159.87, time: '2022-11-07T00:00:00Z' },
    { price: 298.11, time: '2022-11-06T00:00:00Z' },
    { price: 269.4, time: '2022-11-05T00:00:00Z' },
    { price: 223.7, time: '2022-11-04T00:00:00Z' },
    { price: 263.12, time: '2022-11-03T00:00:00Z' },
    { price: 263.07, time: '2022-11-02T00:00:00Z' },
    { price: 287.1, time: '2022-11-01T00:00:00Z' },
  ],
}

export const xrp: CryptoPrices = {
  currency: 'XRP',
  name: 'XRP',
  image: 'xrp.png',
  description: `Launched in July 2017, Binance is the biggest cryptocurrency exchange globally based on daily trading volume. Binance aims to bring cryptocurrency exchanges to the forefront of financial activity globally. The idea behind Binance’s name is to show this new paradigm in global finance — Binary Finance, or Binance.`,
  total: 19854568,
  prices: [
    { price: 0.46, time: '2022-12-22T00:00:00Z' },
    { price: 0.46, time: '2022-12-21T00:00:00Z' },
    { price: 0.46, time: '2022-12-20T00:00:00Z' },
    { price: 0.46, time: '2022-12-19T00:00:00Z' },
    { price: 0.46, time: '2022-12-18T00:00:00Z' },
    { price: 0.46, time: '2022-12-17T00:00:00Z' },
    { price: 0.46, time: '2022-12-16T00:00:00Z' },
    { price: 0.46, time: '2022-12-15T00:00:00Z' },
    { price: 0.46, time: '2022-12-14T00:00:00Z' },
    { price: 0.46, time: '2022-12-13T00:00:00Z' },
    { price: 0.46, time: '2022-12-12T00:00:00Z' },
    { price: 0.46, time: '2022-12-11T00:00:00Z' },
    { price: 0.46, time: '2022-12-10T00:00:00Z' },
    { price: 0.46, time: '2022-12-09T00:00:00Z' },
    { price: 0.46, time: '2022-12-08T00:00:00Z' },
    { price: 0.46, time: '2022-12-07T00:00:00Z' },
    { price: 0.46, time: '2022-12-06T00:00:00Z' },
    { price: 0.46, time: '2022-12-05T00:00:00Z' },
    { price: 0.46, time: '2022-12-04T00:00:00Z' },
    { price: 0.46, time: '2022-12-03T00:00:00Z' },
    { price: 0.46, time: '2022-12-02T00:00:00Z' },
    { price: 0.46, time: '2022-12-01T00:00:00Z' },
    { price: 0.25, time: '2022-11-30T00:00:00Z' },
    { price: 0.26, time: '2022-11-29T00:00:00Z' },
    { price: 0.47, time: '2022-11-28T00:00:00Z' },
    { price: 0.96, time: '2022-11-27T00:00:00Z' },
    { price: 0.73, time: '2022-11-26T00:00:00Z' },
    { price: 0.56, time: '2022-11-25T00:00:00Z' },
    { price: 0.52, time: '2022-11-24T00:00:00Z' },
    { price: 0.69, time: '2022-11-23T00:00:00Z' },
    { price: 0.48, time: '2022-11-22T00:00:00Z' },
    { price: 0.89, time: '2022-11-21T00:00:00Z' },
    { price: 0.95, time: '2022-11-20T00:00:00Z' },
    { price: 0.56, time: '2022-11-19T00:00:00Z' },
    { price: 0.85, time: '2022-11-18T00:00:00Z' },
    { price: 0.69, time: '2022-11-17T00:00:00Z' },
    { price: 0.87, time: '2022-11-16T00:00:00Z' },
    { price: 0.99, time: '2022-11-15T00:00:00Z' },
    { price: 0.85, time: '2022-11-14T00:00:00Z' },
    { price: 0.89, time: '2022-11-13T00:00:00Z' },
    { price: 0.55, time: '2022-11-12T00:00:00Z' },
    { price: 0.59, time: '2022-11-11T00:00:00Z' },
    { price: 0.0, time: '2022-11-10T00:00:00Z' },
    { price: 0.99, time: '2022-11-09T00:00:00Z' },
    { price: 0.68, time: '2022-11-08T00:00:00Z' },
    { price: 0.59, time: '2022-11-07T00:00:00Z' },
    { price: 0.98, time: '2022-11-06T00:00:00Z' },
    { price: 0.69, time: '2022-11-05T00:00:00Z' },
    { price: 0.23, time: '2022-11-04T00:00:00Z' },
    { price: 0.63, time: '2022-11-03T00:00:00Z' },
    { price: 0.63, time: '2022-11-02T00:00:00Z' },
    { price: 0.87, time: '2022-11-01T00:00:00Z' },
  ],
}

export const pax: CryptoPrices = {
  currency: 'PAXG',
  name: 'Pax Gold',
  image: 'pax-gold.png',
  description: `Pax Gold (PAXG) is a gold-backed cryptocurrency, launched by the creators of Paxos Standard (PAX) in September 2019. As an ERC-20 token operating on the Ethereum blockchain, Pax Gold is tradeable on a large variety of exchanges and has become an accessible way for traders to start investing in gold.
  The main goal behind Pax Gold is to make gold more tradable, as the physical commodity is not easily divisible or flexible in terms of transport. This is why Paxos Standard decided to create a cryptocurrency entirely backed by gold. According to the official whitepaper, Pax Gold was created to allow investors to buy indefinitely small amounts of gold through the cryptocurrency, thus virtually eliminating minimum buy limits for the commodity.`,
  total: 19854568,
  prices: [
    { price: 146.01, time: '2022-12-22T00:00:00Z' },
    { price: 146.01, time: '2022-12-21T00:00:00Z' },
    { price: 146.01, time: '2022-12-20T00:00:00Z' },
    { price: 146.01, time: '2022-12-19T00:00:00Z' },
    { price: 146.01, time: '2022-12-18T00:00:00Z' },
    { price: 146.01, time: '2022-12-17T00:00:00Z' },
    { price: 146.01, time: '2022-12-16T00:00:00Z' },
    { price: 146.01, time: '2022-12-15T00:00:00Z' },
    { price: 146.01, time: '2022-12-14T00:00:00Z' },
    { price: 146.01, time: '2022-12-13T00:00:00Z' },
    { price: 146.01, time: '2022-12-12T00:00:00Z' },
    { price: 146.01, time: '2022-12-11T00:00:00Z' },
    { price: 146.01, time: '2022-12-10T00:00:00Z' },
    { price: 146.01, time: '2022-12-09T00:00:00Z' },
    { price: 146.01, time: '2022-12-08T00:00:00Z' },
    { price: 146.01, time: '2022-12-07T00:00:00Z' },
    { price: 146.01, time: '2022-12-06T00:00:00Z' },
    { price: 146.01, time: '2022-12-05T00:00:00Z' },
    { price: 146.01, time: '2022-12-04T00:00:00Z' },
    { price: 146.01, time: '2022-12-03T00:00:00Z' },
    { price: 146.01, time: '2022-12-02T00:00:00Z' },
    { price: 146.01, time: '2022-12-01T00:00:00Z' },
    { price: 125.01, time: '2022-11-30T00:00:00Z' },
    { price: 126.01, time: '2022-11-29T00:00:00Z' },
    { price: 147.01, time: '2022-11-28T00:00:00Z' },
    { price: 196.01, time: '2022-11-27T00:00:00Z' },
    { price: 173.01, time: '2022-11-26T00:00:00Z' },
    { price: 156.01, time: '2022-11-25T00:00:00Z' },
    { price: 152.01, time: '2022-11-24T00:00:00Z' },
    { price: 169.01, time: '2022-11-23T00:00:00Z' },
    { price: 148.01, time: '2022-11-22T00:00:00Z' },
    { price: 189.01, time: '2022-11-21T00:00:00Z' },
    { price: 195.01, time: '2022-11-20T00:00:00Z' },
    { price: 156.01, time: '2022-11-19T00:00:00Z' },
    { price: 185.01, time: '2022-11-18T00:00:00Z' },
    { price: 169.01, time: '2022-11-17T00:00:00Z' },
    { price: 187.01, time: '2022-11-16T00:00:00Z' },
    { price: 199.01, time: '2022-11-15T00:00:00Z' },
    { price: 185.01, time: '2022-11-14T00:00:00Z' },
    { price: 189.01, time: '2022-11-13T00:00:00Z' },
    { price: 155.01, time: '2022-11-12T00:00:00Z' },
    { price: 159.01, time: '2022-11-11T00:00:00Z' },
    { price: 10.01, time: '2022-11-10T00:00:00Z' },
    { price: 199.01, time: '2022-11-09T00:00:00Z' },
    { price: 168.01, time: '2022-11-08T00:00:00Z' },
    { price: 159.01, time: '2022-11-07T00:00:00Z' },
    { price: 198.01, time: '2022-11-06T00:00:00Z' },
    { price: 169.01, time: '2022-11-05T00:00:00Z' },
    { price: 123.01, time: '2022-11-04T00:00:00Z' },
    { price: 163.01, time: '2022-11-03T00:00:00Z' },
    { price: 163.01, time: '2022-11-02T00:00:00Z' },
    { price: 187.01, time: '2022-11-01T00:00:00Z' },
  ],
}

export const decred: CryptoPrices = {
  currency: 'DCR',
  name: 'Decred',
  image: 'decred.png',
  description: `Launched in July 2017, Binance is the biggest cryptocurrency exchange globally based on daily trading volume. Binance aims to bring cryptocurrency exchanges to the forefront of financial activity globally. The idea behind Binance’s name is to show this new paradigm in global finance — Binary Finance, or Binance.`,
  total: 19854568,
  prices: [
    { price: 19.36, time: '2022-12-22T00:00:00Z' },
    { price: 19.35, time: '2022-12-21T00:00:00Z' },
    { price: 20.12, time: '2022-12-20T00:00:00Z' },
    { price: 21.12, time: '2022-12-19T00:00:00Z' },
    { price: 22.12, time: '2022-12-18T00:00:00Z' },
    { price: 24.26, time: '2022-12-17T00:00:00Z' },
    { price: 23.18, time: '2022-12-16T00:00:00Z' },
    { price: 20.12, time: '2022-12-15T00:00:00Z' },
    { price: 18.12, time: '2022-12-14T00:00:00Z' },
    { price: 19.12, time: '2022-12-13T00:00:00Z' },
    { price: 22.12, time: '2022-12-12T00:00:00Z' },
    { price: 25.12, time: '2022-12-11T00:00:00Z' },
    { price: 10.12, time: '2022-12-10T00:00:00Z' },
    { price: 12.12, time: '2022-12-09T00:00:00Z' },
    { price: 16.12, time: '2022-12-08T00:00:00Z' },
    { price: 14.12, time: '2022-12-07T00:00:00Z' },
    { price: 15.12, time: '2022-12-06T00:00:00Z' },
    { price: 26.12, time: '2022-12-05T00:00:00Z' },
    { price: 22.12, time: '2022-12-04T00:00:00Z' },
    { price: 30.12, time: '2022-12-03T00:00:00Z' },
    { price: 36.12, time: '2022-12-02T00:00:00Z' },
    { price: 40.12, time: '2022-12-01T00:00:00Z' },
    { price: 22.85, time: '2022-11-30T00:00:00Z' },
    { price: 22.06, time: '2022-11-29T00:00:00Z' },
    { price: 24.83, time: '2022-11-28T00:00:00Z' },
    { price: 29.59, time: '2022-11-27T00:00:00Z' },
    { price: 27.52, time: '2022-11-26T00:00:00Z' },
    { price: 45.97, time: '2022-11-25T00:00:00Z' },
    { price: 35.55, time: '2022-11-24T00:00:00Z' },
    { price: 36.69, time: '2022-11-23T00:00:00Z' },
    { price: 34.86, time: '2022-11-22T00:00:00Z' },
    { price: 38.44, time: '2022-11-21T00:00:00Z' },
    { price: 39.15, time: '2022-11-20T00:00:00Z' },
    { price: 35.02, time: '2022-11-19T00:00:00Z' },
    { price: 48.02, time: '2022-11-18T00:00:00Z' },
    { price: 36.85, time: '2022-11-17T00:00:00Z' },
    { price: 38.05, time: '2022-11-16T00:00:00Z' },
    { price: 19.72, time: '2022-11-15T00:00:00Z' },
    { price: 28.87, time: '2022-11-14T00:00:00Z' },
    { price: 28.11, time: '2022-11-13T00:00:00Z' },
    { price: 15.4, time: '2022-11-12T00:00:00Z' },
    { price: 25.7, time: '2022-11-11T00:00:00Z' },
    { price: 10.12, time: '2022-11-10T00:00:00Z' },
    { price: 19.07, time: '2022-11-09T00:00:00Z' },
    { price: 16.1, time: '2022-11-08T00:00:00Z' },
    { price: 15.87, time: '2022-11-07T00:00:00Z' },
    { price: 29.11, time: '2022-11-06T00:00:00Z' },
    { price: 26.4, time: '2022-11-05T00:00:00Z' },
    { price: 22.7, time: '2022-11-04T00:00:00Z' },
    { price: 26.12, time: '2022-11-03T00:00:00Z' },
    { price: 26.07, time: '2022-11-02T00:00:00Z' },
    { price: 28.1, time: '2022-11-01T00:00:00Z' },
  ],
}
export const dodgeCoin: CryptoPrices = {
  currency: 'DOGE',
  name: 'Dodge Coin',
  image: 'dodge-coin.png',
  description: `Maker (MKR) is the governance token of the MakerDAO and Maker Protocol — respectively a decentralized organization and a software platform, both based on the Ethereum blockchain — that allows users to issue and manage the DAI stablecoin.
  Initially conceived in 2015 and fully launched in December 2017, Maker is a project whose task is to operate DAI, a community-managed decentralized cryptocurrency with a stable value soft-pegged to the US dollar.
  MKR tokens act as a kind of voting share for the organization that manages DAI; while they do not pay dividends to their holders, they do give the holders voting rights over the development of Maker Protocol and are expected to appreciate in value in accordance with the success of DAI itself.`,
  total: 125447856,
  prices: [
    { price: 5.28, time: '2022-12-22T00:00:00Z' },
    { price: 0.28, time: '2022-12-21T00:00:00Z' },
    { price: 5.36, time: '2022-12-20T00:00:00Z' },
    { price: 0.28, time: '2022-12-19T00:00:00Z' },
    { price: 0.28, time: '2022-12-18T00:00:00Z' },
    { price: 2.28, time: '2022-12-17T00:00:00Z' },
    { price: 0.28, time: '2022-12-16T00:00:00Z' },
    { price: 5.28, time: '2022-12-15T00:00:00Z' },
    { price: 5.28, time: '2022-12-14T00:00:00Z' },
    { price: 0.28, time: '2022-12-13T00:00:00Z' },
    { price: 0.28, time: '2022-12-12T00:00:00Z' },
    { price: 5.28, time: '2022-12-11T00:00:00Z' },
    { price: 0.28, time: '2022-12-10T00:00:00Z' },
    { price: 0.28, time: '2022-12-09T00:00:00Z' },
    { price: 0.28, time: '2022-12-08T00:00:00Z' },
    { price: 5.28, time: '2022-12-07T00:00:00Z' },
    { price: 0.28, time: '2022-12-06T00:00:00Z' },
    { price: 0.28, time: '2022-12-05T00:00:00Z' },
    { price: 5.28, time: '2022-12-04T00:00:00Z' },
    { price: 6.28, time: '2022-12-03T00:00:00Z' },
    { price: 3.28, time: '2022-12-02T00:00:00Z' },
    { price: 2.28, time: '2022-12-01T00:00:00Z' },
    { price: 6.85, time: '2022-11-30T00:00:00Z' },
    { price: 6.06, time: '2022-11-29T00:00:00Z' },
    { price: 2.83, time: '2022-11-28T00:00:00Z' },
    { price: 0.59, time: '2022-11-27T00:00:00Z' },
    { price: 0.52, time: '2022-11-26T00:00:00Z' },
    { price: 0.97, time: '2022-11-25T00:00:00Z' },
    { price: 0.55, time: '2022-11-24T00:00:00Z' },
    { price: 2.69, time: '2022-11-23T00:00:00Z' },
    { price: 0.86, time: '2022-11-22T00:00:00Z' },
    { price: 2.44, time: '2022-11-21T00:00:00Z' },
    { price: 2.15, time: '2022-11-20T00:00:00Z' },
    { price: 5.02, time: '2022-11-19T00:00:00Z' },
    { price: 5.02, time: '2022-11-18T00:00:00Z' },
    { price: 0.85, time: '2022-11-17T00:00:00Z' },
    { price: 2.05, time: '2022-11-16T00:00:00Z' },
    { price: 5.72, time: '2022-11-15T00:00:00Z' },
    { price: 6.87, time: '2022-11-14T00:00:00Z' },
    { price: 0.11, time: '2022-11-13T00:00:00Z' },
    { price: 2.4, time: '2022-11-12T00:00:00Z' },
    { price: 0.7, time: '2022-11-11T00:00:00Z' },
    { price: 1.12, time: '2022-11-10T00:00:00Z' },
    { price: 6.07, time: '2022-11-09T00:00:00Z' },
    { price: 0.1, time: '2022-11-08T00:00:00Z' },
    { price: 2.87, time: '2022-11-07T00:00:00Z' },
    { price: 3.11, time: '2022-11-06T00:00:00Z' },
    { price: 3.4, time: '2022-11-05T00:00:00Z' },
    { price: 6.7, time: '2022-11-04T00:00:00Z' },
    { price: 6.12, time: '2022-11-03T00:00:00Z' },
    { price: 3.07, time: '2022-11-02T00:00:00Z' },
    { price: 7.1, time: '2022-11-01T00:00:00Z' },
  ],
}

export const maker: CryptoPrices = {
  currency: 'Maker',
  name: 'MKR',
  image: 'maker.png',
  description: `Maker (MKR) is the governance token of the MakerDAO and Maker Protocol — respectively a decentralized organization and a software platform, both based on the Ethereum blockchain — that allows users to issue and manage the DAI stablecoin.
  Initially conceived in 2015 and fully launched in December 2017, Maker is a project whose task is to operate DAI, a community-managed decentralized cryptocurrency with a stable value soft-pegged to the US dollar.
  MKR tokens act as a kind of voting share for the organization that manages DAI; while they do not pay dividends to their holders, they do give the holders voting rights over the development of Maker Protocol and are expected to appreciate in value in accordance with the success of DAI itself.`,
  total: 532709250,
  prices: [
    { price: 545.28, time: '2022-12-22T00:00:00Z' },
    { price: 560.28, time: '2022-12-21T00:00:00Z' },
    { price: 585.36, time: '2022-12-20T00:00:00Z' },
    { price: 600.28, time: '2022-12-19T00:00:00Z' },
    { price: 610.28, time: '2022-12-18T00:00:00Z' },
    { price: 612.28, time: '2022-12-17T00:00:00Z' },
    { price: 620.28, time: '2022-12-16T00:00:00Z' },
    { price: 545.28, time: '2022-12-15T00:00:00Z' },
    { price: 545.28, time: '2022-12-14T00:00:00Z' },
    { price: 320.28, time: '2022-12-13T00:00:00Z' },
    { price: 400.28, time: '2022-12-12T00:00:00Z' },
    { price: 545.28, time: '2022-12-11T00:00:00Z' },
    { price: 300.28, time: '2022-12-10T00:00:00Z' },
    { price: 310.28, time: '2022-12-09T00:00:00Z' },
    { price: 400.28, time: '2022-12-08T00:00:00Z' },
    { price: 365.28, time: '2022-12-07T00:00:00Z' },
    { price: 420.28, time: '2022-12-06T00:00:00Z' },
    { price: 500.28, time: '2022-12-05T00:00:00Z' },
    { price: 545.28, time: '2022-12-04T00:00:00Z' },
    { price: 536.28, time: '2022-12-03T00:00:00Z' },
    { price: 563.28, time: '2022-12-02T00:00:00Z' },
    { price: 542.28, time: '2022-12-01T00:00:00Z' },
    { price: 356.85, time: '2022-11-30T00:00:00Z' },
    { price: 456.06, time: '2022-11-29T00:00:00Z' },
    { price: 562.83, time: '2022-11-28T00:00:00Z' },
    { price: 300.59, time: '2022-11-27T00:00:00Z' },
    { price: 290.52, time: '2022-11-26T00:00:00Z' },
    { price: 280.97, time: '2022-11-25T00:00:00Z' },
    { price: 270.55, time: '2022-11-24T00:00:00Z' },
    { price: 232.69, time: '2022-11-23T00:00:00Z' },
    { price: 300.86, time: '2022-11-22T00:00:00Z' },
    { price: 312.44, time: '2022-11-21T00:00:00Z' },
    { price: 352.15, time: '2022-11-20T00:00:00Z' },
    { price: 345.02, time: '2022-11-19T00:00:00Z' },
    { price: 365.02, time: '2022-11-18T00:00:00Z' },
    { price: 320.85, time: '2022-11-17T00:00:00Z' },
    { price: 312.05, time: '2022-11-16T00:00:00Z' },
    { price: 365.72, time: '2022-11-15T00:00:00Z' },
    { price: 326.87, time: '2022-11-14T00:00:00Z' },
    { price: 400.11, time: '2022-11-13T00:00:00Z' },
    { price: 452.4, time: '2022-11-12T00:00:00Z' },
    { price: 400.7, time: '2022-11-11T00:00:00Z' },
    { price: 421.12, time: '2022-11-10T00:00:00Z' },
    { price: 426.07, time: '2022-11-09T00:00:00Z' },
    { price: 500.1, time: '2022-11-08T00:00:00Z' },
    { price: 512.87, time: '2022-11-07T00:00:00Z' },
    { price: 523.11, time: '2022-11-06T00:00:00Z' },
    { price: 523.4, time: '2022-11-05T00:00:00Z' },
    { price: 456.7, time: '2022-11-04T00:00:00Z' },
    { price: 356.12, time: '2022-11-03T00:00:00Z' },
    { price: 263.07, time: '2022-11-02T00:00:00Z' },
    { price: 287.1, time: '2022-11-01T00:00:00Z' },
  ],
}

export const CRYPTO_CURRENCY = [bitcoin, maker, decred, bnb, ethereum, polygon, xrp, dodgeCoin, pax]
